export const endpoints = {
  createCustomer: '/customer/create',
}
